import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import { TableColumnsFilterComponent, Tables } from '../../../../../Components';
import {
  TableActions,
  ColumnsFilterPagesEnum,
  TableFilterTypesEnum,
  HighlightRowKeys,
  ActionsButtonsEnum,
} from '../../../../../Enums';
import {
  GlobalHistory,
  showError 
} from '../../../../../Helper';
import { ActiveItemActions } from '../../../../../store/ActiveItem/ActiveItemActions';
import { VendorsTableHeaderData } from './VendorsTableHeaderData';
import { TableColumnsFilterActions } from '../../../../../store/TableColumnsFilter/TableColumnsFilterActions';
import { ActivitiesManagementDialog } from '../../../../../SharedComponents/ActivitiesManagementDialog/ActivitiesManagementDialog';
import { GetAllFormFieldsByFormId } from '../../../../../Services'

export const VendorsTableComponent = ({
  filter , 
  pathName ,
  checkedCards ,
  setCheckedCards ,
  checkedCardsIds ,
  vendorsTableFilter ,
  onFilterValuesChanged ,
  setCheckedCardsIds ,
  setFilter ,
  detailsVendorsList ,
  activeSelectedAction ,
  translationPath ,
  parentTranslationPath ,
  setOrderBy ,
  isClearFiltersClicked ,
  setIsClearFiltersClicked ,
  displyOpenFileButton ,
  formId ,
  closeSideMenu , 
  onRowClick ,
  isOneSelect 
}) => {
  const dispatch = useDispatch();
    const { t } = useTranslation(parentTranslationPath);
  
  const [tableColumns, setTableColumns] = useState([]);
  const [allFormFields, setAllFormFields] = useState([]);
  const [isAllFormFieldsLoading ,setIsAllFormFieldsLoading] = useState(false) ; 
  const [tableFilterData, setTableFilterData] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [addActivity, setAddActivity] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
   const [detailedCardAction, setdetailedCardAction] = useState(() => ({
    actionEnum: '',
    item: '',
  }));
  const [selectedTableFilterColumns, setSelectedTableFilterColumns] = useState(
    VendorsTableHeaderData(t).filter((item) => item.isDefaultFilterColumn).map((column) => column?.id)
  );
  const tableColumnsFilterResponse = useSelector((state) => state.TableColumnsFilterReducer);
  const [defaultPrefernces, setDefaultPrefernces] = useState([
    {
      enum: TableActions.openFile.key,
    },
    {
      enum: TableActions.addActivity.key,
    },
  ]);
  const [activePrefernces, setActiveprefernces] = useState(defaultPrefernces);



  const tableActionClicked = useCallback(
    async (actionEnum, item, focusedRow, event) => {
      event.stopPropagation();
      event.preventDefault();
      setActiveItem(item);
      localStorage.setItem('contactReletedWithDeveloper' ,  item?.contactId || item?.vendor_name?.id)
      dispatch(ActiveItemActions.activeItemRequest(item));
     if (actionEnum === TableActions.openFile.key) {
        GlobalHistory.push(
          `/home/vendors/vendor-profile-edit?form=${formId}&id=${item.id}`
        );
        if(closeSideMenu)
        closeSideMenu() ; 
       
    } else if (actionEnum === TableActions.addActivity.key) 
      setAddActivity(true);
    
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, pathName ,formId]
  );
  const getIsSelected = useCallback(
    (row) => checkedCards && checkedCards.findIndex((item) => item.id === row.id) !== -1,
    [checkedCards]
  );
  const getIsDisabled = useCallback(
    (row) =>
      (isOneSelect && checkedCardsIds && checkedCardsIds.length === 9 && !getIsSelected(row)) ||
      (checkedCardsIds && checkedCardsIds.length > 9 && !getIsSelected(row)) ||
      (checkedCards && checkedCards[0] && checkedCards[0].userTypeId !== row?.userTypeId),
    [checkedCards, checkedCardsIds, getIsSelected, isOneSelect]
  );
  const onSelectClicked = useCallback(
    (row) => {
      const isObsoleteContact = checkedCardsIds && checkedCardsIds.length !== 0;
      const isContactWithTransaction = (isObsoleteContact && row.isWithTransaction === 1 && !getIsSelected(row))

      const itemIndex = checkedCardsIds ? checkedCardsIds.findIndex((item) => item === row.id) : -1;
      if (itemIndex !== -1) {
        checkedCardsIds.splice(itemIndex, 1);
        setCheckedCards((items) => {
          const elementIndex = items.findIndex((item) => item.id === row.id);
          if (elementIndex !== -1) items.splice(elementIndex, 1);
          return [...items];
        });
      } else if (!isContactWithTransaction) {
        checkedCardsIds.push(row.id);
        setCheckedCards((items) => {
          items.push(row);
          return [...items];
        });
      } else if (isContactWithTransaction) showError(`Absolete Contacts Can't Have Transactions`);

      setCheckedCardsIds(checkedCardsIds);
    },
    [checkedCardsIds, setCheckedCards, setCheckedCardsIds]
  );

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };

  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));

  };

  const focusedRowChanged = useCallback(
    (rowIndex, item) => {
      if (rowIndex !== -1 && onRowClick) onRowClick(item, rowIndex);
      let  currentActiveActions = [];
      defaultPrefernces.map((a)=> {
        if(a && a.enum === TableActions.openFile.key &&  (displyOpenFileButton || true )  )
          currentActiveActions.push(a) ; 
        if(a && a.enum === TableActions.addActivity.key)
          currentActiveActions.push(a) ; 
      });

      setActiveprefernces(currentActiveActions);
    },
    [defaultPrefernces, onRowClick]
  );

  
  const getAllFormFieldsByFormId = useCallback(async () => {
    setIsAllFormFieldsLoading(true);
    Promise.all([
      await GetAllFormFieldsByFormId(formId),
    ])
      .then((result) => {
        if (Array.isArray(result[0])) {
          const concantinateFields = result[0]
            .filter(
              (field, index, array) =>
                array.findIndex((element) => element.formFieldKey === field.formFieldKey) === index
            );
          const list = concantinateFields.filter(e =>
            e.formFieldName !== 'vendor_logo' &&
            e.formFieldName !== 'map'
          ).map((field) => ({
            ...field,
            id: field.formFieldId || null,
            key: field.formFieldKey || null,
            isDate: field.uiWidgetType === 'alt-date' || false,
            label: (field.formFieldTitle && field.formFieldTitle.replace('*', '')) || '',
            input: field.displayPath || '',
            isNumber:
              field.propertyJson && JSON.parse(field.propertyJson).schema &&
              field.propertyJson && JSON.parse(field.propertyJson).schema.specialKey === 'currency' ||
              field.propertyJson && JSON.parse(field.propertyJson).schema &&
              field.propertyJson && JSON.parse(field.propertyJson).schema.specialKey === 'decimal' ||
              field.propertyJson && JSON.parse(field.propertyJson).schema &&
              field.propertyJson && JSON.parse(field.propertyJson).schema.specialKey === 'size'
            ,
           // isSortable: true,
           isHiddenFilter: true ,
            searchableKey: field.searchableKey,
          }));
          setAllFormFields(list);
        } else setAllFormFields([]);
        setIsAllFormFieldsLoading(false);
      })
      .catch(() => {
        setAllFormFields([]);
        setIsAllFormFieldsLoading(false);
      });
  }, [formId]);

  // useEffect(() => {
  //   if(formId)
  //   getAllFormFieldsByFormId();
  // }, [getAllFormFieldsByFormId]);

  useEffect(() => {
    if (
      tableColumnsFilterResponse && tableColumnsFilterResponse[ColumnsFilterPagesEnum.Vendors.key] 
    ) {
      setSelectedTableFilterColumns(
        tableColumnsFilterResponse && tableColumnsFilterResponse[ColumnsFilterPagesEnum.Vendors.key] 
      );
    }
  }, [tableColumnsFilterResponse]);

  useEffect(() => {
    setTableColumns([
      ...VendorsTableHeaderData(t).filter(
        (item) => selectedTableFilterColumns.findIndex((element) => element === item?.id) !== -1
      ),
       ... allFormFields
        .filter(
          (item) =>
            selectedTableFilterColumns.findIndex((element) => element === item.formFieldId) !== -1
        )
        .map((field) => ({
          id: field.formFieldId || null,
          key: field.formFieldKey || null,
          isDate: field.uiWidgetType === 'alt-date' || false,
          label: (field.formFieldTitle && field.formFieldTitle.replace('*', '')) || '',
          input: field.displayPath || '',
          optionFilterList :field.optionFilterList ,
          isNumber:
            field.propertyJson && JSON.parse(field.propertyJson).schema &&
            field.propertyJson && JSON.parse(field.propertyJson).schema.specialKey === 'currency' ||
            field.propertyJson && JSON.parse(field.propertyJson).schema &&
            field.propertyJson && JSON.parse(field.propertyJson).schema.specialKey === 'decimal' ||
            field.propertyJson && JSON.parse(field.propertyJson).schema &&
            field.propertyJson && JSON.parse(field.propertyJson).schema.specialKey === 'size'
          ,
          //isSortable: true,
          isHiddenFilter: true ,
          searchableKey: field.searchableKey,
        })),
    ]);

  }, [allFormFields, selectedTableFilterColumns, vendorsTableFilter]);

  useEffect(() => {
    setTableFilterData(
      tableColumns.map((column) => ({
        key: column.key || column.fieldKey || column.id,
        filterType:
          (column.isDate && TableFilterTypesEnum.datePicker.key) ||
          (column.withSelectFilter && TableFilterTypesEnum.selectOption.key) ||
          (column.isNumber && TableFilterTypesEnum.numberInput.key) ||
          TableFilterTypesEnum.textInput.key,
        isHiddenFilter: column.isHiddenFilter,
        isHidden: column.isHidden,
        textInputType: column.textInputType,
        textInputMax: column.textInputMax,
        textInputMin: column.textInputMin,
        searchableKey: column.searchableKey || column.input,
        optionFilterList: column.optionFilterList,
        displayPath:
          (column.key && column.input) ||
          (column.fieldKey &&
            allFormFields &&
            allFormFields.findIndex(
              (item) => item.formFieldKey === column.fieldKey
            ) !== -1 &&
            allFormFields.find((item) => item.formFieldKey === column.fieldKey)
              .displayPath) ||
          undefined,
      }))
    );
  }, [allFormFields, tableColumns]);


  useEffect(() => {
    if (sortBy)
      setOrderBy((item) => ({ ...item, filterBy: sortBy.filterBy && sortBy.filterBy[0].toLowerCase() + sortBy.filterBy.slice(1), orderBy: sortBy.orderBy, fieldType: sortBy.fieldType }));
  }, [sortBy]);
  

  return (
    <div className='w-100 px-3'>

      <TableColumnsFilterComponent
        columns={VendorsTableHeaderData(t).filter(item => !item.isHidden ).concat(
          allFormFields &&  allFormFields.filter(
            (item) =>
              VendorsTableHeaderData(t).findIndex(
                (element) => element?.fieldKey === item?.formFieldKey
              ) === -1
          )
        ).map((item) => ({
          key: item.formFieldId || item.id || item.input ,
          value: (item.formFieldTitle && item.formFieldTitle.replace('*', '')) || item.label || item.input ,
        }))}
        isLoading={isAllFormFieldsLoading}
        selectedColumns={selectedTableFilterColumns}
        onSelectedColumnsChanged={(newValue) => {
          setSelectedTableFilterColumns(newValue);
          let localTableColumnsFilterResponse = tableColumnsFilterResponse;
          if (localTableColumnsFilterResponse)
            localTableColumnsFilterResponse[ColumnsFilterPagesEnum.Vendors.key] = newValue ;
          else {
            localTableColumnsFilterResponse = {
              [ColumnsFilterPagesEnum.Vendors.key]: newValue ,
            };
          }
          dispatch(
            TableColumnsFilterActions.TableColumnsFilterRequest(localTableColumnsFilterResponse)
          );
        }}
        parentTranslationPath={parentTranslationPath}
        translationPath=''
      />
      <Tables
        isWithCheckboxColumn={[
          'merge',
          ActionsButtonsEnum[4].id,
          ActionsButtonsEnum[29].id,
        ].includes(activeSelectedAction)}
        data={detailsVendorsList.result}
        HideSellectAll
        TotalSelect={(checkedCardsIds && checkedCardsIds.length) || 0}
        selectAllOptions={
          (["merge", ActionsButtonsEnum[4].id, ActionsButtonsEnum[29].id].includes(activeSelectedAction) && {
            selectedRows: checkedCardsIds,
            getIsSelected,
            disabledRows: [],
            getIsDisabled,
            onSelectClicked,
          }) ||
          undefined
        }
        headerData={tableColumns}
        defaultActions={activePrefernces}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
        actionsOptions={{
          onActionClicked: tableActionClicked,
        }}
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
        parentTranslationPath={parentTranslationPath}
        focusedRowChanged={focusedRowChanged}
        totalItems={detailsVendorsList ? detailsVendorsList.totalCount : 0}
        filterValues={vendorsTableFilter}
        onFilterValuesChanged={onFilterValuesChanged}
        filterData={tableFilterData}
        isWithFilter
        setSortBy={setSortBy}
        setIsClearFiltersClicked={setIsClearFiltersClicked}
        isClearFiltersClicked={isClearFiltersClicked}
        isLoading={isAllFormFieldsLoading}
        localStorageKey='VendorsFilter'
        highlightedRowKey={HighlightRowKeys.Vondors.key}
      />
      {
        addActivity && (
          <ActivitiesManagementDialog
            open={addActivity}
            parentTranslationPath={'ContactProfileManagementView'}
            contactId={(activeItem?.vendor_name?.id)}
            //contactClassificationId={activeItem?.vendor_class?.lookupItemId}
            isVendorActivity
            actionItemId={(activeItem?.vendor_name?.id)}
            translationPath={''}
            onSave={() => {
              setAddActivity(false);
            }}
            close={() => {
              setAddActivity(false);

            }}
          />
        )
      }

    </div>
  );
};
VendorsTableComponent.propTypes = {
  isWithCheckboxColumn: PropTypes.bool,
  isOneSelect: PropTypes.bool,
  pathName: PropTypes.string.isRequired,
  setCheckedCards: PropTypes.func.isRequired,
  onPageSizeChanged: PropTypes.func.isRequired,
  setCheckedCardsIds: PropTypes.func.isRequired,
  onPageIndexChanged: PropTypes.func.isRequired,
  onFilterValuesChanged: PropTypes.func.isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  checkedCards: PropTypes.instanceOf(Object).isRequired,
  checkedCardsIds: PropTypes.instanceOf(Object).isRequired,
  detailsVendorsList: PropTypes.instanceOf(Object).isRequired,
  activeSelectedAction: PropTypes.instanceOf(Object).isRequired,
  vendorsTableFilter: PropTypes.instanceOf(Object),
  setActiveTab: PropTypes.func.isRequired,
  setIsClearFiltersClicked: PropTypes.bool,
  isClearFiltersClicked: PropTypes.bool,
  displyOpenFileButton: PropTypes.bool,
};
VendorsTableComponent.defaultProps = {
  isWithCheckboxColumn: false,
  vendorsTableFilter: undefined,
  isOneSelect: false,
  displyOpenFileButton: false,
  closeSideMenu: ()=>{},
};
